// routing
import Routes from "routes";

// project imports
import Locales from "ui-component/Locales";
import NavigationScroll from "layout/NavigationScroll";
import ThemeCustomization from "themes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// auth provider
import { FirebaseProvider as AuthProvider } from "contexts/FirebaseContext";
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { JWTProvider as AuthProvider } from 'contexts/JWTContext';

//css
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file

// ==============================|| APP ||============================== //

const App = () => (
  //@ts-ignore
  <ThemeCustomization>
    {/* RTL layout */}
    <Locales>
      <NavigationScroll>
        <AuthProvider>
          <>
            <Routes />
            {/* <Snackbar /> */}
          </>
        </AuthProvider>
      </NavigationScroll>
    </Locales>
  </ThemeCustomization>
);

export default App;
